import { addLocaleData } from 'react-intl';
import type { Locale } from 'react-intl';

function getLocaleAbsoluteUrl(localeUrl: string, locale: string) {
  if (!localeUrl.endsWith('/')) {
    localeUrl = `${localeUrl}/`;
  }
  return `${localeUrl}messages_${locale}.json`;
}
export async function getTranslations(localeBaseUrl: string, locale: string) {
  const url = getLocaleAbsoluteUrl(localeBaseUrl, locale);
  const response = await fetch(url);
  return response.json();
}

// eslint-disable-next-line complexity
function pluralRuleFunction(n: number, ord: boolean) {
  const s = String(n).split('.');
  const v0 = !s[1];
  const t0 = Number(s[0]) === n;
  const n10 = t0 && s[0].slice(-1);
  const n100 = t0 && s[0].slice(-2);

  if (ord)
    return n10 === '1' && n100 !== '11'
      ? 'one'
      : n10 === '2' && n100 !== '12'
      ? 'two'
      : n10 === '3' && n100 !== '13'
      ? 'few'
      : 'other';

  return n === 1 && v0 ? 'one' : 'other';
}

export const addDummyLocaleData = (locale: string) => {
  const localeData = {
    locale,
    fields: {},
    pluralRuleFunction,
  } as Locale;

  addLocaleData(localeData);
};
